import { Advertiser, Client } from '@features/clients';
import { ReportType } from './report';
import { CampaignType } from './campaign';
import { CampaignListAttribute, CampaignListEntry } from '../slice/schemas';
import { GridSortDirection } from '@mui/x-data-grid';

export type SelectableItem = Client | Advertiser;

export type FilterParams = {
  searchText: string;
  selectedCampaignType: CampaignType;
  selectedReportType: ReportType;
  selectedClient: Client | null;
  checkedAdvertisers: SelectableItem[];
  approvalStatus?: CampaignListEntry['approvalStatus'];
  reportDateFrom?: string;
};

export type PaginationParams = {
  page: number;
  pageSize: number;
  sortKey: CampaignListAttribute;
  sortDirection: GridSortDirection;
};

export const initialState: FilterParams = {
  selectedCampaignType: 'all',
  selectedReportType: 'overall',
  searchText: '',
  selectedClient: null,
  checkedAdvertisers: [],
};
